"use strict";

var $ = window.$;
var mapboxgl = window.mapboxgl;
var mapinfo = window.mapinfo;
$(function () {
  mapboxgl.accessToken = mapinfo.accessToken;
  var map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: mapinfo.center,
    zoom: mapinfo.zoom,
    scrollZoom: false,
    doubleClickZoom: false,
    touchZoomRotate: false
  });
  map.addControl(new mapboxgl.NavigationControl());
  var popup = new mapboxgl.Popup({
    closeOnClick: false,
    offset: 25
  }).setHTML(mapinfo.markerText);
  new mapboxgl.Marker().setLngLat(mapinfo.center).setPopup(popup).addTo(map).togglePopup(); // HANDLE PAN WITH 2 FINGERS ON MOBILE
  // https://github.com/mapbox/mapbox-gl-js/issues/2618

  var panStart = {
    x: 0,
    y: 0
  };
  map.getContainer().addEventListener('touchstart', touchStart, false);
  map.getContainer().addEventListener('touchmove', touchMove, false);
  if ('ontouchstart' in document.documentElement) map.dragPan.disable();

  function touchStart(event) {
    if (event.touches.length === 2) {
      event.stopImmediatePropagation();
      event.preventDefault();
      var x = 0;
      var y = 0;

      for (var _i = 0, _Array$from = Array.from(event.touches); _i < _Array$from.length; _i++) {
        var touch = _Array$from[_i];
        x += touch.screenX;
        y += touch.screenY;
      }

      panStart.x = x / event.touches.length;
      panStart.y = y / event.touches.length;
    }
  }

  function touchMove(event, callback) {
    if (event.touches.length === 2) {
      event.stopImmediatePropagation();
      event.preventDefault();
      var x = 0;
      var y = 0;

      for (var _i2 = 0, _Array$from2 = Array.from(event.touches); _i2 < _Array$from2.length; _i2++) {
        var touch = _Array$from2[_i2];
        x += touch.screenX;
        y += touch.screenY;
      }

      var movex = x / event.touches.length - panStart.x;
      var movey = y / event.touches.length - panStart.y;
      panStart.x = x / event.touches.length;
      panStart.y = y / event.touches.length;
      map.panBy([movex * 1 / -1, movey * 1 / -1], {
        animate: false
      });
    }
  }
});